import { useEffect } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";

const DELETE_STEP_CONFIRM_DIALOG_ID = "delete-step-confirmation-modal";

interface DeleteStepConfirmModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteStepConfirmModal = ({
  onClose,
  onConfirm,
}: DeleteStepConfirmModalProps) => {
  useEffect(() => {
    openModal(DELETE_STEP_CONFIRM_DIALOG_ID);
  }, []);

  const handleConfirm = () => {
    onConfirm();
    closeModal(DELETE_STEP_CONFIRM_DIALOG_ID);
  };

  return (
    <Modal
      dialogId={DELETE_STEP_CONFIRM_DIALOG_ID}
      title="Delete Step"
      saveButtonText="Yes, Delete"
      cancelText="Cancel"
      onSave={handleConfirm}
      onCancel={onClose}
      onClose={onClose}
    >
      <div className="flex flex-col items-center justify-center gap-3 py-2">
        <div className="text-center text-sm text-primaryGray-3">
          Are you sure you want to delete this step? This action cannot be
          undone.
        </div>
      </div>
    </Modal>
  );
};

export default DeleteStepConfirmModal;
